module.exports = __webpack_public_path__ + "zilla-slab-latin-700italic.ffc7a913cbee9f6ba2f69179fdf543d6.woff2";